"use client";
import { useEffect, useState, type ReactNode } from "react";

export type SSRWrapperProps = {
  children: ReactNode;
  fallback?: ReactNode;
};

export const SSRWrapper = ({ children, fallback = null }: SSRWrapperProps) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(typeof window !== "undefined");
  }, []);

  return isClient ? children : fallback;
};
